export const GET_ME = 'CURRENTUSER/GET_ME'
export const FETCH_ME_PENDING = 'CURRENTUSER/FETCH_ME_PENDING'
export const FETCH_ME_FULFILLED = 'CURRENTUSER/FETCH_ME_FULFILLED'
export const FETCH_ME_REJECTED = 'CURRENTUSER/FETCH_ME_REJECTED'
